import router from "@/router";
import store from "@/store";
import { getDevToken } from "@/shared/devToken";
import { isLiveWallboard } from "@/shared/wallboardDate";
import {
  clearSsoSession,
  isJwt,
  refreshSsoTokens,
  shouldRetryUnauthorized,
  startBackend2Login,
} from "@/shared/ssoAuth";

function authHeaders(token) {
  const headers = {};
  if (!token) {
    return headers;
  }
  if (isJwt(token)) {
    headers.Authorization = "Bearer " + token;
  } else {
    headers["x-api-key"] = token;
  }
  return headers;
}

function xhrGet(url, headers) {
  return new Promise(function (resolve, reject) {
    const xhr = new XMLHttpRequest();
    xhr.open("GET", url, true);
    xhr.timeout = 20000;
    const names = Object.keys(headers || {});
    for (let i = 0; i < names.length; i++) {
      xhr.setRequestHeader(names[i], headers[names[i]]);
    }
    xhr.onreadystatechange = function () {
      if (xhr.readyState !== 4) return;
      const body = xhr.responseText || "";
      resolve({
        ok: xhr.status >= 200 && xhr.status < 300,
        status: xhr.status,
        statusText: xhr.statusText || "",
        text: function () {
          return Promise.resolve(body);
        },
        json: function () {
          return Promise.resolve().then(function () {
            if (!body) return null;
            return JSON.parse(body);
          });
        },
      });
    };
    xhr.onerror = function () {
      reject(new Error("network"));
    };
    xhr.ontimeout = function () {
      reject(new Error("timeout"));
    };
    xhr.send();
  });
}

function currentToken() {
  const query = router.currentRoute.value.query;
  return store.getters.getAccessToken || getDevToken(query.token) || null;
}

export const useFetch = async (url, params = {}) => {
  if (!params.addQueryParams) {
    params.addQueryParams = false;
  }
  if (!params.useToken) {
    params.useToken = true;
  }

  const query = router.currentRoute.value.query;
  const urlObj = new URL(url);
  const token = currentToken();
  const headers = params.useToken ? authHeaders(token) : {};

  if (params.addQueryParams && Object.keys(query).length > 0) {
    Object.keys(query).forEach((key) => {
      if (key === "token") return;
      if (isLiveWallboard() && key === "date") return;
      urlObj.searchParams.append(key, query[key]);
    });
  }

  if (params.certifiedPartnerId) {
    urlObj.searchParams.append(
      "certified_partner_id",
      params.certifiedPartnerId
    );
  }

  const response = await xhrGet(urlObj.href, headers);

  if (
    (response.status === 401 || response.status === 403) &&
    !params._retried &&
    shouldRetryUnauthorized(urlObj.href)
  ) {
    const next = await refreshSsoTokens();
    if (next) {
      store.dispatch("setAccessToken", next);
      return useFetch(url, { ...params, _retried: true });
    }
    if (next === false) {
      clearSsoSession();
      startBackend2Login();
    }
  }

  return response;
};
